import React from "react";
import PropTypes from "prop-types";
import TnelectionHeader2026 from "../rows/tnelection-header-2026";
import { addWithoutAdsToTemplates } from "../get-collection-template";
import { LazyCollection } from "@quintype/components";
import styles from "./tn-election.m.css";
import { GA, WebEngage, DeepBI, PGAD } from "../../integrations";
import { PAGE_TYPE } from "../../constants";

const newTemplates = addWithoutAdsToTemplates("home");
function getAdsWrappedCollectionTemplate(designTemplate) {
  return newTemplates[designTemplate] || newTemplates.defaultTemplate;
}

const TNElectionPage = ({ data, pageType }) => {
  React.useEffect(
    () => {
      GA.registerPageView(pageType || PAGE_TYPE.TN_ELECTION_PAGE, { collection: data.collection });
      WebEngage.registerPageView();
      DeepBI.registerPageView({ collection: data.collection });
      PGAD.loadScript();
    },
    [pageType]
  );
  const metaImg = data.collection.metadata["cover-image"]["cover-image-s3-key"];

  return (
    <div className={`${styles["election-page-wrapper"]} ${pageType || ""}`}>
      <TnelectionHeader2026 showMenu={true} />
      <div className="container">
        {pageType !== "mobile-webpage-page" && (
          <div className={styles["election-header"]}>
            <img src={`https://media.vikatan.com/${metaImg}`} />
          </div>
        )}
        <LazyCollection
          collection={data.collection}
          magazine={data.magazine}
          //  config={this.props.config}
          collectionTemplates={getAdsWrappedCollectionTemplate}
          lazyAfter={4}
          accentColor={"#2f81cd"}
        />
      </div>
    </div>
  );
};
export { TNElectionPage };

TNElectionPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  }),
  pageType: PropTypes.string
};
